export default __webpack_public_path__ + "static/modularfrp4-23c9d4a6d3dc9521930c588073fe017e.jpg";